import { timeList } from "./hardDataset";
import moment from "moment";
export const DEFAULT_LOCALE = "en";
export let noOptionSelectedFromRepeatListItem = { name: "None", id: "N" };
export let dayValues = {
  Mon: "mon",
  Tue: "tue",
  Wed: "wed",
  Thu: "thu",
  Fri: "fri",
  Sat: "sat",
  Sun: "sun"
};

//minimum required parameters by save api :
/*
applyto : "thisandfuture"
availableduration : "PT00M"
bufferpostduration:"PT00M"
duration:"PT30M"
recurrence:{frequency: "N"}
frequency:"N"
resourceid:116896
secondduration:"PT00M"
serviceid:1654301
starttime:"20171206T000000L"
*/

export const checkoutModesEnum = {
  VIEW_MODE: "viewMode",
  PAYMENT_MODE: "paymentMode"
};

export const offersStatusEnum = {
  ACTIVE: "ACTIVE"
};

export const paymentModeEnum = {
  CARD_MODE: "cardPaymentMode",
  CASH_MODE: "cashPaymentMode",
  GIFT_MODE: "giftCardPaymentMode"
};

export const paymentStatusEnum = {
  STATUS_PAID: "invoicePaid",
  STATUS_PARTIAL: "invoicePartialPaid",
  STATUS_UNPAID: "invoiceUnpaid",
  STATUS_UNKNOWN: "invoiceUnknown"
};

export const globalErrorInitialState = {
  message: ""
};

export const globalSuccessInitialState = {
  message: "",
  icon: ""
};

export const checkoutAppointmentStepInitialState = {
  tipPopupVisible: false,
  giftCertSaleFormVisible: false,
  discountMenuVisible: false,
  checkoutMode: checkoutModesEnum.VIEW_MODE,
  posSettings: null,
  giftCertSetting: null,
  invoiceData: {},
  bookingPaymentsData: null,
  invoicePdfData: null,
  paymentMode: paymentModeEnum.CARD_MODE,
  paymentHistoryList: [],
  giftCertValueList: [],
  foundGiftCertData: null,
  paymentSetting: {
    loading: false
  },
  checkoutAppointmentStepData: {
    shouldSaveAppointmentOnceWeGoBackFromCustomerProfile: false,
    shouldUpdateInvoiceToBooking: false,
    isEditingServicePrice: false,
    updateInvoiceAfterPayment: false,
    haveDownloadDataAfterCashOrGiftPayment: false,
    printInvoicePdf: false,
    checkoutServicePrice: "",
    invoiceKey: null,
    shareInvoiceEmail: "",
    bookingRevenue: 0,
    customTipAmount: "",
    taxAmount: 0,
    selectedDiscountPercentage: 0,
    nameOnCard: "",
    cardNumberValid: false,
    cardExpValid: false,
    cardCvvValid: false,
    paymentAmount: "0",
    giftCertCode: "",
    giftCertRedemptionAmount: "0",
    giftCertSaleValue: "0",
    giftCertSaleTitle: "",
    didDoRefund: false,
    editedInvoiceItemPrice: {},
    doCreditCardFormPayment: false,
    isNewPriceLessThanInvoicePaid: false //DES-771
  }
};

export let initialAdvancedServiceWithDefaultData = () => {
  return {
    splitAppointmentFreeTime: "",
    splitAppointmentFinishTime: "",
    splitAppointmentBufferTime: ""
  };
};

export const advancedAppointmentStepInitialState = {
  advancedAppointmentStepData: {
    futureAppointmentClashes: [],
    futureAppointmentClashesResolved: [],
    selectedTimeNumberOption: { id: "1timeNumberrecurring", value: 2 },
    recurringOnTimeList: timeList,
    timeListForClashes: timeList,
    timeListForOnTimeRecurring: timeList,
    unavailableSpecificRecurringTimeList: [],
    selectedEndDate: {},
    currentClashBeingResolved: 1,
    selectedRecurringOnDate: {},
    selectedEveryDayOption: { id: "1dayrecurring", value: 1 },
    selectedEveryWeekOption: { id: "1weekrecurring", value: 1 },
    selectedEveryMonthOption: { id: "1monthrecurring", value: 1 },
    selectedRecurringEndOfPeriodRadioOption: "untilDate",
    selectedRepeatOption: noOptionSelectedFromRepeatListItem,
    offerId: null,
    validOfferPurchasedId: "",
    bookingCameFromDbWithOffer: false,
    selectedRepeatOnMonthOptionSelected: "dayofweek",
    selectedRecurringOnTime: "",
    multiServiceAdvancedList: [initialAdvancedServiceWithDefaultData()],
    recurringToggleOn: false,
    selectedRepeatOnOptionsSelected: [],
    listOfNonEditableRepeatOnOptionsSelected: [],
    recurringOnTimeSelectedList: []
  },
  advancedAppointmentStepDataFromLastSave: {
    selectedTimeNumberOption: {},
    recurringOnTimeList: [],
    selectedEndDate: {},
    selectedEveryDayOption: {},
    selectedEveryWeekOption: {},
    selectedEveryMonthOption: {},
    multiServiceAdvancedList: [initialAdvancedServiceWithDefaultData()],
    selectedRecurringEndOfPeriodRadioOption: "",
    selectedRepeatOption: {},
    offerId: null,
    selectedRepeatOnMonthOptionSelected: "",
    splitAppointmentFreeTime: "",
    selectedRecurringOnTime: "",
    splitAppointmentFinishTime: "",
    splitAppointmentBufferTime: "",
    recurringToggleOn: false,
    selectedRepeatOnOptionsSelected: [],
    listOfNonEditableRepeatOnOptionsSelected: [],
    recurringOnTimeSelectedList: []
  },
  loadedAvailabilitiesForSpecificRecurringAtLeastOnce: false,
  loadingAvailabilityDatesForSpecificRecurringSection: false,
  openEndDatePickerAppointment: false,
  openRecurringOnDatePickerAppointment: false
};

export const bookingInitialState = {
  sibblingBookingIds: [],
  sibblingsLoaded: 0,
  currentBookingId: undefined,
  loadingPurchasedOffer: false,
  isMultiServiceAppointment: false,
  sendingBookingEmail: false,
  gotValidOffer: false,
  finishedLoadingSibblingBookings: false,
  savingBooking: false,
  sibblingBookingsTotalStartingFromZero: 0,
  resourcesLoadedForSibblings: 0,
  finishedLoadingSibblingResources: false,
  loadedResourcesForAllSibblings: -1
};

export const menuNamesEnum = {
  FIRST_STEP_APPOINTMENT: "first-step-appointment",
  SECOND_STEP_ADVANCED: "second-step-advanced",
  THIRD_STEP_CHECKOUT: "third-step-checkout",
  INTERMEDIATE_STEP_CUSTOMER_PROFILE_CREATE:
    "intermediate-step-customer-profile-create",
  INTERMEDIATE_STEP_CUSTOMER_RECENT_APPOINTMENTS:
    "intermediate-step-customer-history",
  INTERMEDIATE_STEP_CUSTOMER_NOTES: "intermediate-step-customer-notes",
  INTERMEDIATE_STEP_CUSTOMER_PROFILE_EDIT:
    "intermediate-step-customer-profile-edit",
  INTERMEDIATE_STEP_BOOKING_ONLY_CUSTOMER_PROFILE:
    "intermediate-step-booking-only-customer-profile-edit"
};

export let getCleanService = function() {
  return {
    availableduration: null,
    bufferpostduration: "",
    categories: [],
    colorcode: "",
    created: "",
    deleted: false,
    description: null,
    duration: "",
    hidden: false,
    offline: false,
    id: null,
    modified: "",
    name: "",
    order: 1,
    price: "",
    publishcost: true,
    requireaddress: false,
    resources: [],
    secondduration: null,
    type: 1
  };
};

export let initialServiceWithDefaultData = function() {
  return {
    indexAmongstSibblings: 0,
    selectedDate: moment(
      moment().format("YYYY") +
        "-" +
        moment().format("MM") +
        "-" +
        moment().format("DD") +
        "T" +
        moment().format("HH:mm")
    ),
    serviceSearchQuery: "",
    selectedService: getCleanService(),
    offerPrice: 0,
    originalOfferprice: 0,
    appointmentDuration: "00:30",
    temporarilySelectedTime: null,
    selectedTime: { value: "" },
    selectedStaff: {},
    serviceDropdownOpen: false,
    appointmentEndTimeFromApi: { value: "" },
    openDatePickerAppointment: false,
    loadedBookingForResourceWithinDates: false,
    loadingTimesForCurrentResource: false,
    timeDropdownOpen: false,
    staffNoPreference: false
  };
};

export let getEmptyCustomer = () => {
  return {
    email: "",
    address: {},
    firstname: "",
    id: null,
    lastname: "",
    noShow: 0,
    notYetSaved: false,
    phone: "",
    blocked: false
  };
};

export const appointmentStepInitialState = {
  appointmentStepData: {
    appType: "offlinebooking",
    appUsage: null,
    invoiceKey: null,
    timeSlotsContainingAppointments: [],
    loadingCustomersList: false,
    unavailableTimeList: [],
    showMemoFullView: false,
    loadingInvoice: false,
    bookingObtainedFromDbWithCustomer: false,
    showNotesFullView: false,
    loadingExistingBooking: false,
    clientSpecialRequestComments: "",
    appointmentDatabaseCustomerId: null,
    paymentStatus: paymentStatusEnum.STATUS_UNKNOWN,
    staffList: [],
    customerList: [],
    selectedCustomer: getEmptyCustomer(),
    isNewBooking: true,
    confirmationSent: false,
    selectedAppointmentStatus: {},
    multiServiceList: [initialServiceWithDefaultData()],
    timeList: timeList,
    customerNameOrPhonenumberSearchQuery: "",
    appointmentNotes: "",
    serviceList: [],
    statusList: [
      {
        id: 3 //booked
      },
      {
        id: 4 //completed
      },
      {
        id: 8 //no-show
      },
      {
        id: 5 //cancelled
      }
    ],
    organizationId: "",
    businessName: "",
    address: {
      address1: "",
      city: "",
      state: "",
      postalcode: ""
    },
    triggerSaveForThisBookingSinceTheUserDragAndDroppedBookingFormInNewSlot: false,
    isAppointmentDragAndDrop: false
  },
  finishedLoadingBooking: false,
  loadedCachedData: false,
  isSibblingsMissingInUpdate: false,
  paymentsEnabled: false,
  currentUserId: undefined,
  roles: [],
  limitedPermissions: {
    canCreateCustomerProfile: true,
    canViewAndEditCheckoutInvoicesForAllBookings: true,
    canViewCustomerProfile: true,
    canEditCustomerProfile: true,
    canSearchForCustomers: true,
    canCheckoutAllBookings: true,
    bookingsCheckoutableByCurrentUser: [],
    canEditAllBookings: true,
    bookingsEditableByCurrentUser: [undefined]
  },
  timezone: "",
  doubleBookingEnabled: false,
  customerDropdownOpen: false,
  finishedLoadingServicesAndOrganizationData: false,
  isShowingAddressForm: false,
  temporaryBookingAddress: {
    // required because adding address in appointment is now a 2 step process
    address1: "",
    city: "",
    state: "",
    postalcode: ""
  },
  businessCountryCode: ""
};

export const waitlistStepInitialState = {
  waitlistStepData: {
    loadingCustomersList: false,
    customerList: [],
    databaseCustomerId: null,
    serviceList: [],
    staffList: [],
    bookingDates: [],
    waitlistDates: [],
    closedDates: [],
    loadingServiceResourceAvaialbility: false,
    startTimes: [],
    finishTimes: [],
    organizationId: "",
    businessName: "",
    savingWaitlist: false,
    submitError: false,
    submitSuccess: false,
    selectedCustomer: getEmptyCustomer()
  },
  loadedCachedData: false,
  currentUserId: undefined,
  roles: [],
  limitedPermissions: {
    canCreateCustomerProfile: true,
    canViewAndEditCheckoutInvoicesForAllBookings: true,
    canViewCustomerProfile: true,
    canEditCustomerProfile: true,
    canSearchForCustomers: true,
    canCheckoutAllBookings: true,
    bookingsCheckoutableByCurrentUser: [],
    canEditAllBookings: true,
    bookingsEditableByCurrentUser: [undefined],
    displaystaffonline: null,
    displaynopreference: null
  },
  timezone: "",
  finishedLoadingServicesAndOrganizationData: false,
  businessCountryCode: ""
};

export const languageProviderInitialState = {
  locale: DEFAULT_LOCALE
};

export let appStatusInitialState = {
  currentAppStatus: "online",
  appIsVisible: false,
  openCancelAppointmentModal: false
};

export let customerInitialState = {
  customerProfileValidationFormIsGood: false
};

export const customerProfileInitialState = {
  loadingCustomerProfile: false,
  customerProfileData: {
    firstName: "",
    lastName: "",
    noShow: "",
    email: "",
    phoneNumber: "",
    address: {
      address1: "",
      city: "",
      state: "",
      postalcode: ""
    },
    blocked: false,
    captureCreditCard: false
  },
  bookingOnlyCustomerProfileData: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    address: {}
  },
  apiCustomerProfileData: {},
  apiErrorReasons: null,
  gotCustomerProfileData: false
};

export const customerNotesInitialState = {
  customerRecentNotes: [],
  isCustomerNoteEditorOpen: false,
  newCustomerNote: "",
  editingNoteId: null,
  expandedNoteid: null,
  isLoading: false,
  apiErrorReasons: null
};

export const customerRecentAppointmentsInitialState = {
  customerRecentAppointments: [],
  isLoading: false,
  apiErrorReasons: null
};

export let menuInitialState = {
  currentMenu: menuNamesEnum.FIRST_STEP_APPOINTMENT,
  checkoutPreviousMenu: menuNamesEnum.FIRST_STEP_APPOINTMENT,
  goBackFromCheckout: false,
  closeAppointmentModalVisible: false,
  sendCancellationEmailToggled: false,
  cancelAppointmentVisible: false,
  restoreAppointmentModalVisible: false,
  goBackFromCustomerPageModalVisible: false,
  recursiveAppointmentConfirmationModalVisible: false,
  closeAppWhenRecursiveAppointmentModalCloses: false,
  multiserviceAppointmentConfirmationModalVisible: false,
  closeWaitlistModalVisible: false,
  bookingCustomerProfileModalVisible: false
};

export const initialState = {
  appStatusReducer: appStatusInitialState,
  languageProviderReducer: languageProviderInitialState,
  customerReducer: customerInitialState,
  customerRecentAppointmentsReducer: customerRecentAppointmentsInitialState,
  customerNotesReducer: customerNotesInitialState,
  customerProfileReducer: customerProfileInitialState,
  menuReducer: menuInitialState,
  bookingReducer: bookingInitialState,
  appointmentStepReducer: appointmentStepInitialState,
  advancedAppointmentStepReducer: advancedAppointmentStepInitialState,
  waitlistStepReducer: waitlistStepInitialState
};
